import { ProLayoutProps, Settings as LayoutSettings } from '@ant-design/pro-layout';

const Settings: LayoutSettings & {
  pwa?: boolean;
  logo?: string;
} & ProLayoutProps = {
  navTheme: 'light',
  // 拂晓蓝

  // primaryColor: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'T-connect',
  pwa: false,
  logo: '/images/logo_welcome.png',
  iconfontUrl: '',
  token: {
    header: {
      colorBgHeader: '#0255da',
      colorHeaderTitle: '#fff',
      colorTextMenu: '#dfdfdf',
      colorTextMenuSecondary: '#dfdfdf',
      colorTextMenuSelected: '#fff',
      colorBgMenuItemSelected: '#22272b',
      colorTextRightActionsItem: '#dfdfdf',
    },
    sider: {
      colorTextMenuSelected: '#1890ff',
      colorBgMenuItemSelected: '#e6f7ff',
      colorTextMenuItemHover: '#1890ff',
      colorBgMenuItemHover: '#e6f7ff',
    },
    bgLayout: '#f0f2f5',
  },
};

export default Settings;
